import { render, staticRenderFns } from "./ProspectsLostRelaunchTab.vue?vue&type=template&id=09bb8819"
import script from "./ProspectsLostRelaunchTab.vue?vue&type=script&lang=js"
export * from "./ProspectsLostRelaunchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports